import { render, staticRenderFns } from "./PageSettings.vue?vue&type=template&id=32a5fefc"
import script from "./PageSettings.vue?vue&type=script&lang=js"
export * from "./PageSettings.vue?vue&type=script&lang=js"
import style0 from "./PageSettings.vue?vue&type=style&index=0&id=32a5fefc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports